// src/guard.ts
var createIsGuard = (type) => (value) => typeof value === type;
var isString = createIsGuard("string");
var isNumber = createIsGuard("number");
var isBigInt = createIsGuard("bigint");
var isBoolean = createIsGuard("boolean");
var isSymbol = createIsGuard("symbol");
var isObject = createIsGuard("object");
var isUndefined = createIsGuard("undefined");
var isNotNullish = (value) => value != null;
var isNullish = (value) => value == null;

export {
  isString,
  isNumber,
  isBigInt,
  isBoolean,
  isSymbol,
  isObject,
  isUndefined,
  isNotNullish,
  isNullish
};
